import { useAtomValue, useSetAtom } from "jotai";
import { EditIcon } from "@/icons/widget-menu";
import { widgetMenuOptionsAtom, widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import type { MenuOptionResult, SetActiveSubMenu } from "../../types";
import { applyValue } from "../applyValue";
import { setNewOptions } from "../setNewOptions";

interface UseEditButtonProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function useEditButton({ setActiveSubMenu }: UseEditButtonProps): MenuOptionResult {
    const options = useAtomValue(widgetMenuOptionsByNameAtom("mobileEdit"));
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);

    const handleClick = () => {
        setActiveSubMenu(null);

        const setNewMobileEditOptions = setNewOptions({ name: "mobileEdit", setWidgetMenuOptions });

        applyValue({ options, value: "", setNewOptions: setNewMobileEditOptions });
    };

    return {
        content: <EditIcon />,
        handleClick,
    };
}
